<template>
  <div :class="$style.container">
    <div>
      <router-link
        v-for="post in bookmarks" :key="post.uuid"
        :to="{ name: 'app-blogs-post', params: { blogId: post.blog.shortId, postId: post.uuid } }"
        :class="$style.link"
      >
        <BlogPostListItem
          :post="post"
          :class="$style.post"
        />
      </router-link>
      <infinite-loading
        @infinite="infiniteHandler"
        :class="$style.infiniteLoading"
      >
        <Spinner slot="spinner" />
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/Spinner'
import BlogPostListItem from './BlogPostListItem'

const OFFSET = 20

export default {
  name: 'blog-bookmarks',
  components: {
    InfiniteLoading,
    Spinner,
    BlogPostListItem
  },

  data () {
    return {
      page: 0
    }
  },
  computed: {
    ...mapGetters({
      bookmarks: 'entities/posts/bookmarks'
    })
  },
  methods: {
    ...mapActions({
      fetchBookmarks: 'entities/posts/fetchBookmarks'
    }),
    async infiniteHandler ($state) {
      const posts = await this.fetchBookmarks({
        limit: OFFSET,
        offset: OFFSET * this.page
      })
      if (posts.length < OFFSET) {
        $state.complete()
      } else {
        $state.loaded()
        this.page += 1
      }
    }
  }
}
</script>

<style module lang="scss">
.container {
  padding: 8px 20px;
  overflow-x: hidden;
  overflow-y: scroll;
  flex: 1;
}
.link:not(:last-child) .post {
  border-bottom: 1px solid $border-color;
}
.infiniteLoading {
  height: 50px;
  padding: 20px 0;
}
</style>
